import * as React from "react";
import type { SVGProps } from "react";

const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M10 18.32q2.28 0 4.22-1.14a7.9 7.9 0 0 0 2.96-2.96A8.2 8.2 0 0 0 18.32 10q0-2.28-1.14-4.22a7.9 7.9 0 0 0-2.96-2.96A8.2 8.2 0 0 0 10 1.68q-2.26 0-4.2 1.14A8.2 8.2 0 0 0 2.82 5.8 8.14 8.14 0 0 0 1.68 10q0 2.26 1.14 4.2a8.04 8.04 0 0 0 2.96 2.98q1.94 1.14 4.22 1.14m0-1.64q-1.8 0-3.36-.92a6.5 6.5 0 0 1-2.4-2.4A6.5 6.5 0 0 1 3.32 10q0-1.8.92-3.36a6.5 6.5 0 0 1 2.4-2.4A6.5 6.5 0 0 1 10 3.32q1.8 0 3.36.92a6.5 6.5 0 0 1 2.4 2.4q.92 1.56.92 3.36t-.92 3.36a6.5 6.5 0 0 1-2.4 2.4q-1.56.92-3.36.92m.82-9.18V5.82H9.18V7.5zm0 6.68v-5H9.18v5z" />
  </svg>
);
export default SvgInfo;
